import "./../assets/css/style.css";
import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ImgBanner } from "./banner";
import { BoxTitle } from "./box";
import { Section } from "./section";
import { TitleMarca } from "./Text";

import Imagemteste from "../img/banner/destaque-banner.png";

function DestaqueCyber() {
  const DestaqueSlick = {
    dots: true,
    arrows: true,
    speed: 500,
    infinite:true,
    slidesToShow: 4,
    slidesToScroll: 4,
    centerMode: true,
    responsive: [
      { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } }
    ],
  };
  /* const Aprrove = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/approve.png';
  const Betel = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/betel.png';
  const Braziline = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/braziline.png';
  const Coca = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/coca-cola.png';
  const colcci = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/colcci.png';
  const Diversao = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/diversao.png';
  const Fila = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/fila.png';
  const Hang = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/hang loose.png';
  const Hurley = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/hurley.png';
  const Kenner = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/kenner.png';
  const Mizuno= 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/mizuno.png';
  const Nicoboco= 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/nicoboco.png';
  const Oakley = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/oakley.png';
  const Olympikus = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/olympikus.png';
  const Oxn= 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/oxn.png';
  const Puma = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/puma.png';
  const Redley = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/redley.png';
  const Retromania = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/retro-mania.png';
  const SurfCenter = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/surf-center.png';
  const Umbro = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/umbro.png';
  const UnderArmour = 'https://blackfriday.futfanatics.com.br/img/destaque/destaque-cyber/under-armour.png'; */

  return (
    <Slider {...DestaqueSlick} className="slick-destaque">
    <div className="item">
      <a href="https://www.futfanatics.com.br/loja/busca.php?loja=311840&marca=marca_adidas&range=&order=0">
        <ImgBanner src={require('../img/2025/cyber/destaque/adidas.png')} />
      </a>
    </div>
    <div className="item">
      <a href="https://www.futfanatics.com.br/loja/busca.php?loja=311840&marca=marca_betel&range=&order=1">
        <ImgBanner src={require('../img/2025/cyber/destaque/betel.png')} />
      </a>
    </div>
    <div className="item">
      <a href="https://www.futfanatics.com.br/loja/busca.php?loja=311840&marca=marca_braziline&range=&order=4">
        <ImgBanner src={require('../img/2025/cyber/destaque/braziline.png')} />
      </a>
    </div>
    <div className="item">
      <a href="https://www.futfanatics.com.br/kappa">
        <ImgBanner src={require('../img/2025/cyber/destaque/kappa.png')} />
      </a>
    </div>
    
    <div className="item">
      <a href="https://www.futfanatics.com.br/loja/busca.php?loja=311840&marca=marca_kenner&range=&order=1">
        <ImgBanner src={require('../img/2025/cyber/destaque/kenner.png')} />
      </a>
    </div>
    <div className="item">
      <a href="https://www.futfanatics.com.br/new-balance?order=3">
        <ImgBanner src={require('../img/2025/cyber/destaque/new_balance.png')} />
      </a>
    </div>
    <div className="item">
      <a href="https://www.futfanatics.com.br/loja/busca.php?loja=311840&marca=marca_nicoboco&range=&order=1">
        <ImgBanner src={require('../img/2025/cyber/destaque/nicoboco.png')} />
      </a>
    </div>
    <div className="item">
      <a href="https://www.futfanatics.com.br/loja/busca.php?loja=311840&marca=marca_oakley&range=">
        <ImgBanner src={require('../img/2025/cyber/destaque/oakley.png')} />
      </a>
    </div>
    <div className="item">
      <a href="https://www.futfanatics.com.br/olympikus?&order=3">
        <ImgBanner src={require('../img/2025/cyber/destaque/olympikus.png')} />
      </a>
    </div>
    <div className="item">
      <a href="https://www.futfanatics.com.br/loja/catalogo.php?loja=311840&categoria=2&marca=marca_puma&order=1">
        <ImgBanner src={require('../img/2025/cyber/destaque/puma.png')} />
      </a>
    </div>
    <div className="item">
      <a href="https://www.futfanatics.com.br/loja/busca.php?loja=311840&marca=marca_oakley&range=">
        <ImgBanner src={require('../img/2025/cyber/destaque/redley.png')} />
      </a>
    </div>
    <div className="item">
      <a href="https://www.futfanatics.com.br/loja/busca.php?loja=311840&marca=marca_skechers&range=">
        <ImgBanner src={require('../img/2025/cyber/destaque/skechers.png')} />
      </a>
    </div>
    <div className="item">
      <a href="https://www.futfanatics.com.br/loja/busca.php?loja=311840&marca=marca_umbro&range=&order=0">
        <ImgBanner src={require('../img/2025/cyber/destaque/umbro.png')} />
      </a>
    </div>
    
  </Slider>
  );
}

export default DestaqueCyber;
